import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";

import { theme } from "../../../theme";
import { fetchResendOtp } from "../../service";
import { Context } from "../../Provider";
import { formatPhoneNumber } from "../../../utils";
import { showNotification } from "../../../common/notifications/notifications";
import { getPhoneNumberOtpResendCount, setPhoneNumberOtpResendCount } from "../../../storage/phoneNumberOtpResendCount";
import { getEmailOtpResendCount, setEmailOtpResendCount } from "../../../storage/emailOtpResendCount";

const ResendCountdown = ({ ftm, currentStep, setShowEdit }) => {
    const { state } = useContext(Context);
    const { commonSettings } = state;

    const [isLoading, setIsLoading] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const [resendCount, setResendCount] = useState(0);

    const isPhone = currentStep === 1;
    const contactLabel = isPhone ? "phone number" : "email address";

    useEffect(() => {
        const emailOtpResendCount = getEmailOtpResendCount();
        const phoneNumberOtpResendCount = getPhoneNumberOtpResendCount();

        setResendCount(isPhone ? phoneNumberOtpResendCount : emailOtpResendCount);
        setIsLoading(false);
        setCountdown(commonSettings?.otp_validity_period || 60);
    }, [commonSettings?.otp_validity_period, currentStep, isPhone]);

    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => setCountdown(prev => prev - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [countdown]);

    const handleResendClick = () => {
        if (countdown > 0 || isLoading) return;
        resendCount >= commonSettings?.otp_resend_message_show_count ? confirmContactDetails() : sendOtp();
    };

    const confirmContactDetails = () => {
        const formattedContact = isPhone
            ? formatPhoneNumber(ftm?.ftm_contact_number, commonSettings?.phone_number_format || "+44 799 999 9999")
            : ftm?.ftm_email;

        const message = `Could you please confirm if the following phone number is correct: <b>${contactLabel} ${formattedContact}</b>?`;

        showNotification({
            notificationType: "RESEND_OTP",
            orderedMessage: message,
            isConfirmed: sendOtp,
            notConfirmed: () => {
                setShowEdit(true);
            },
        });
    };

    const sendOtp = async () => {
        try {
            setIsLoading(true);
            const response = await fetchResendOtp(ftm?.ftm_id, currentStep === 1 ? 1 : 2);

            if (response.status === 'Success') {
                toast.success("OTP resent successfully");
                setCountdown(commonSettings?.otp_validity_period || 60);
                // setCountdown(5);

                const newCount = resendCount + 1;
                setResendCount(prev => prev + 1);

                !isPhone ? setEmailOtpResendCount(newCount) : setPhoneNumberOtpResendCount(newCount);
            } else {
                toast.error(response?.message || "Failed to resend OTP");
            }
        } catch (error) {
            console.error("Error resending OTP:", error);
            toast.error("Failed to resend OTP");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ul className="list-unstyled mx-auto mt-4">
            <li className="d-flex">
                <p className="mb-0">Didn't get the code?</p>
                <span
                    className={`ms-auto text-gradient text-${theme.main}`}
                    style={{
                        cursor: countdown > 0 || isLoading ? "not-allowed" : "pointer",
                        opacity: countdown > 0 ? 0.6 : 1,
                    }}
                    onClick={handleResendClick}
                >
                    {countdown > 0 ? `Resend in ${countdown}s` : isLoading ? "Waiting..." : "Resend"}
                </span>
            </li>
        </ul>
    );
};

export default ResendCountdown;